import { LabelVisibility } from '@aibees/elephant/types/label';
import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { FormControlLabel, Switch, SwitchProps } from '@mui/material';
import { memo, useState } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ListVisibilitySwitchProps as Props } from './types';

export const ListVisibilitySwitch = memo(({ className, onSubmit }: Props) => {
  const [checked, setChecked] = useState(false);

  const handleChangeSwitch: SwitchProps['onChange'] = (e) => {
    setChecked(e.target.checked);
    const visibility = e.target.checked
      ? LabelVisibility.PRIVATE
      : LabelVisibility.INTERNAL;

    onSubmit?.(visibility);
  };

  return (
    <Styled.Wrapper
      className={classnames('ListVisibilitySwitch', className)}
      sx={SX.root}
    >
      <Icon name="lock-rounded" />

      <FormControlLabel
        labelPlacement="start"
        control={
          <Switch
            checked={checked}
            onChange={handleChangeSwitch}
            size="small"
          />
        }
        label="Private"
      />
    </Styled.Wrapper>
  );
});

ListVisibilitySwitch.displayName = 'ListVisibilitySwitch';
